// extracted by mini-css-extract-plugin
export default {"sponsors":"sponsors_sponsors__XyLl7","sponsorsList":"sponsors_sponsorsList__GlqQC"};